module.exports = __webpack_public_path__ + "static/media/gel.bfa4f1d0.svg";